import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x_url",
  "use": "icon-x_url-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"icon-x_url\">\n    <path d=\"M9.6215 7.59734L14.0893 2.51562H13.0307L9.14958 6.92709L6.05201 2.51562H2.47852L7.16369 9.18713L2.47852 14.5156H3.53709L7.63311 9.85588L10.905 14.5156H14.4785L9.6215 7.59734ZM8.17116 9.2457L7.69573 8.58095L3.91884 3.2965H5.54502L8.59399 7.5628L9.06742 8.22755L13.0302 13.7728H11.404L8.17116 9.2457Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol